import authenticateIcon from '@assets/authenticate.svg';
import { Button } from '@cof/omni-react';
import { SandboxMessageScreen } from '@/components/Sandbox/SandboxMessageScreen/SandboxMessageScreen';

export const AuthenticateScreen = ({
  onAccept,
  onUnrecognized,
}: {
  onAccept: () => void;
  onUnrecognized?: () => void;
}) => (
  <SandboxMessageScreen
    title="You are attempting to authenticate using AirKey"
    body="Get your AirKey card ready before you proceed"
    icon={authenticateIcon}
  >
    <Button
      style={{ marginTop: '24px', width: '100%' }}
      onClick={onAccept}
    >
      Verify with AirKey
    </Button>
    {onUnrecognized && (
      <button
        style={{
          background: 'none',
          border: 'none',
          color: 'white',
          cursor: 'pointer',
          marginTop: '16px',
          textDecoration: 'underline',
        }}
        onClick={onUnrecognized}
      >
        I don&apos;t recognize this request
      </button>
    )}
  </SandboxMessageScreen>
);
